import { Base, base } from "./base"

export type FontWeights = Base

export const fontWeights: FontWeights = {
  ...base
}
